import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FJTextToImageLeftContainer from './FJTextToImageLeft/container/FJTextToImageLeftContainer.jsx';
import FJTextToImageRightContainer from './FJTextToImageRight/container/FJTextToImageRightContainer.jsx';
import FJActionTextToImage from '../../redux/action/FJActionTextToImage.js';

function FJTextToImage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(FJActionTextToImage.initTextToImageDataAction());
    }, [dispatch]);

    return (
        <>
            <FJTextToImageLeftContainer />
            <FJTextToImageRightContainer />
        </>
    );
}

export default FJTextToImage;
